enum PaymentMethod {
  CASH = 'cash',
  CREDIT_CARD = 'credit-card',
  ONLINE = 'online',
}

export default PaymentMethod;
